import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {MvsCrudService} from "../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {MenuItem} from "primeng/api";
import {EuRegistrationService} from "../../../../service/api/eu-registration.service";
import {EuUserService} from "../../../../service/api/eu-user.service"
import {OverviewKpiBaseComponent} from "../../../../../../core/shared/overview/overview-kpi-base.component";
import {KpiHeaderDto} from "../../../../../../core/shared/overview/dto/kpi-header.dto";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";


@Component({
    selector: 'eu-kpi',
    templateUrl: 'eu-kpi.component.html',
    standalone: false
})
export class EuKpiComponent extends OverviewKpiBaseComponent implements OnInit, OnChanges, OnDestroy {

    userDeviceService: MvsCrudService;
    totalUsers: number = 0;
    totalRegistrations: number = 0;
    thisMonthLogins: number = 0;
    thisWeekLogins: number = 0;

    kpiHeaderDto: KpiHeaderDto[];
    items: MenuItem[] | undefined = [{label: 'End User Module'}];

    constructor(
        protected coreService: MvsCoreService,
        
        protected registrationService: EuRegistrationService,
        protected userService: EuUserService) {
        super()

        this.userDeviceService = this.coreService.getCrudService("eu.EuUserDevice");
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
        this.getTotalUsers();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    getTotalUsers() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['active'],
            [new ObjectRequestListAttribute('active', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.userService.groupBy(objectRequestList).subscribe(res => {
            this.totalUsers = res.entries.reduce((acc, item) => acc + item['active_count'], 0);
            this.getTotalRegistrations();
        }, error => {
            this.getTotalRegistrations();
        });
    }

    getTotalRegistrations() {
        const objectRequestList2 = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['deviceType', "createdDate"],
            [new ObjectRequestListAttribute('deviceType', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.registrationService.groupBy(objectRequestList2).subscribe(res => {
            this.totalRegistrations = res.entries.length;
            this.getThisMonthLogins();
        }, error => {
            this.getThisMonthLogins();
        });
    }

    getThisMonthLogins() {
        const objectRequestList = this.getThisMonthRequest('deviceType');
        this.userDeviceService.groupBy(objectRequestList).subscribe(res => {
            this.thisMonthLogins = res.entries.reduce((acc, item) => acc + item['deviceType_count'], 0);
            this.getThisWeekLogins();
        }, error => {
            this.getThisWeekLogins();
        });
    }

    getThisWeekLogins() {
        const objectRequestList = this.getThisWeekRequest('deviceType');
        this.userDeviceService.groupBy(objectRequestList).subscribe(res => {
            this.thisWeekLogins = res.entries.reduce((acc, item) => acc + item['deviceType_count'], 0);
            this.initKpiHeaderDto();
        }, error => {
            this.initKpiHeaderDto();
        });
    }


    initKpiHeaderDto() {

        this.kpiHeaderDto = [
            {
                label: 'Total Users', value: [this.totalUsers],
            },
            {
                label: 'Total Registration', value: [this.totalRegistrations],
            },
            {
                label: 'This Month Logins', value: [this.thisMonthLogins],
            },
            {
                label: 'This Week Logins', value: [this.thisWeekLogins],
            },
        ]
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
